/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CurrencyResponse, V1CurrenciesListError } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Currency<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Currency
   * @name V1CurrenciesList
   * @request GET:/api/v1/currencies
   * @secure
   * @response `200` `(CurrencyResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1CurrenciesList = (params: RequestParams = {}) =>
    this.http.request<CurrencyResponse[], V1CurrenciesListError>({
      path: `/api/v1/currencies`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
